<script>
import { mapState } from 'vuex';
import UserPic from 'components/ui/UserPic';
import UserInfo from 'components/ui/UserInfo';

export default {
  props: [
    'type',
    'theme',
    'src',
    'size',
    'title',
    'dataTestTitle',
    'subtitle',
    'status',
    'counter',
    'avatar',
  ],
  components: {
    UserPic,
    UserInfo,
  },
  computed: {
    ...mapState('app', ['mode', 'isFrame']),
    ...mapState('home', ['ucceIntegration']),
    ucceEnabled() {
      return this.ucceIntegration;
    },
    miniMode() {
      return this.mode === 'MINI' && this.isFrame && !this.ucceEnabled;
    },
    fullMode() {
      return this.mode === 'FULL' || !this.isFrame;
    },
  },
};
</script>

<template lang="pug">
div(:class="[$style.root, status && $style[status], miniMode && $style.rootMini]", :data-counter="(status || counter) && (counter || '')")
  user-pic(:type="type", :theme="theme", :src="src", :class="$style.pic", :size="size", data-test="MENU_USER")
  user-info(:title="title", :data-test-title="dataTestTitle", :subtitle="subtitle")
  div(:class="[$style.tip, miniMode && $style.tipMini, $style.tipOnhold]" v-if="status === 'onhold'") HOLD
  div(:class="[$style.tip, miniMode && $style.tipMini, $style.tipNew]" v-if="status === 'new'") NEW
</template>

<style module lang="sass">
.root
  display: flex
  align-items: center
  position: relative
  z-index: 10
  &[data-counter]:before
    content: attr(data-counter)
    position: absolute
    z-index: 10
    top: 1px
    left: -7px
    width: 18px
    height: 18px
    line-height: 18px
    text-align: center
    text-indent: -0.2em
    letter-spacing: -0.1em
    border-radius: 50%
    border: 1px solid $white
    background: $color_bg_light_accent
    transition: background $a_speed
    color: $white
    font-size: 12px
    font-weight: 500
  &Mini
    &[data-counter]:before
      width: 12px
      height: 12px
      line-height: 14px
.ready[data-counter]:before, .new[data-counter]:before
  background: $color_green
.online[data-counter]:before
  background: $color_main
.offline[data-counter]:before
  background: $color_red
.busy[data-counter]:before
  background: $color_orange
.not_ready[data-counter]:before
  background: $color_red
.onhold[data-counter]:before
  background: grey
.tip
  position: absolute
  top: 0
  right: -16px
  z-index: 20
  font-size: 14px
  font-weight: bold
  color: #fff
  border: 1px solid #fff
  border-radius: 5px
  padding: 0px 5px
  &Mini
    font-size: 8px
  &Onhold
    background: $color_red
  &New
    background: $color_blue !important
.pic
  margin-right: 8px
  flex-shrink: 0

</style>
